import React, { createContext, ReactNode, useContext } from "react";

import { EntityType } from "@/queries";

export interface ChooseEntityConfig {
  selectLatest: boolean;
  types: EntityType[];
  mode: "single" | "multi";
  allowDuplicateVariants: boolean;
  selectSmartTableSheet: boolean;
}

const defaultChooseEntityConfig: ChooseEntityConfig = {
  selectLatest: true,
  types: [],
  mode: "single",
  allowDuplicateVariants: false,
  selectSmartTableSheet: false,
};

const ChooseEntityConfigContext = createContext<ChooseEntityConfig | false>(false);

export const useChooseEntityConfig = () => useContext(ChooseEntityConfigContext);

interface ChooseEntityConfigProviderProps {
  children: ReactNode;
  config?: Partial<ChooseEntityConfig>;
}

export const ChooseEntityConfigProvider = ({
  children,
  config,
}: ChooseEntityConfigProviderProps) => {
  const value = { ...defaultChooseEntityConfig, ...config };

  return (
    <ChooseEntityConfigContext.Provider value={value}>
      {children}
    </ChooseEntityConfigContext.Provider>
  );
};
